var path = 'public/app/features/datasources/partials/http_settings_next.html';
var html = "<datasource-http-settings-next on-change=onChange datasourceconfig=current showaccessoptions=showAccessOption defaulturl=suggestUrl />\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;